import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, ShieldCheckIcon, ActivityIcon, CalendarIcon } from 'lucide-react';
export function SportsRecovery() {
  const cards = [{
    icon: HeartPulseIcon,
    title: 'Recovery',
    desc: 'Focus on post-workout recovery, circulation support, and soreness reduction. Help your body recover faster after intense physical exertion and training blocks.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Injury',
    desc: "Support the body's healing process for acute and chronic injuries. Target pain, inflammation, and mobility restrictions to get back to your active lifestyle."
  }, {
    icon: ActivityIcon,
    title: 'Post-Surgery',
    desc: 'Support rehabilitation, range of motion, and tissue recovery as part of a provider-directed care plan following surgical procedures.'
  }];
  return <section className="py-20 md:py-32 bg-brand-charcoal relative overflow-hidden" data-id="element-183">
      {/* Athletic Background Elements */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-30" data-id="element-184"></div>
      <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-b from-transparent to-brand-navy/80 pointer-events-none" data-id="element-185"></div>

      <div className="container mx-auto px-4 max-w-7xl relative z-10" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-187">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-laser-red/20 text-brand-laser-red border border-brand-laser-red/30 text-sm font-bold tracking-widest mb-4 uppercase" data-id="element-188">
            Performance & Rehab
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-189">
            Get Back in the <span className="text-brand-teal" data-id="element-190">Game Faster</span>
          </h2>
          <p className="text-xl text-gray-300" data-id="element-191">
            Whether you're a competitive athlete or just want to stay active,
            laser therapy supports your body's ability to perform, recover, and
            heal.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-192">
          {cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.2
        }} className="bg-brand-navy/50 backdrop-blur-md border border-white/10 rounded-2xl p-8 hover:bg-brand-navy/70 transition-colors duration-300" data-id="element-193">
              <div className="w-16 h-16 bg-brand-teal/20 rounded-xl flex items-center justify-center mb-6" data-id="element-194">
                <card.icon className="w-8 h-8 text-brand-teal" data-id="element-195" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-196">
                {card.title}
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-197">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center" data-id="element-198">
          <button className="px-10 py-5 bg-brand-laser-red hover:bg-red-600 text-white rounded-lg font-bold text-xl transition-all duration-300 inline-flex items-center justify-center gap-2 shadow-lg shadow-brand-laser-red/25 uppercase tracking-wide" data-id="element-199">
            <CalendarIcon className="w-6 h-6" data-id="element-200" />
            Schedule Your Recovery Session
          </button>
        </motion.div>
      </div>
    </section>;
}